import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../../data/Axios/DynamicForm";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../../data/Axios/DynamicService";
import { accountFields } from "../../../../data/DynamicTable/AccountsDynamicForms";
import { AccountsandFinanceurl } from "../../../../config";
import {
  executeAnyMutation,
  fetchJsonDynamic,
} from "../../../../data/DynamicServiceNew/jsondynamicservice";
import {
  allAccountCategories,
  allAccountSubCategories,
} from "../../../../data/Axios/queries";

const base_url = AccountsandFinanceurl.uri;

const AccountsForm = (props) => {
  const [CategoryData, setCategoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const initialValues = {
    accountName: props.data ? props.data.AccountName : "",
    accountNumber: props.data ? props.data.AccountNumber : "",
    accountType: props.data ? props.data.AccountType : "",
    currency: props.data ? props.data.Currency : "",
    accountCategoryId: props.data ? props.data.AccountCategoryId : "",
  };
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const companyId = parseInt(decodedToken.CompanyId);
  useEffect(() => {
    async function fetchAllData() {
      try {
        const data = await fetchJsonDynamic(
          "accountSubCategory",
          null,
          null,
          base_url
        );
        if (data?.results) {
          setCategoryData(JSON.parse(data?.results));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchAllData();
  }, []);
  const CategoryOptions = CategoryData
    ? CategoryData.map((data) => ({
        parent_key: data.Id,
        value: data.Id,
        label: data.AccountCategory,
      }))
    : [];

  const fields = [
    ...accountFields,
    {
      name: "accountCategoryId",
      label: "Account Category ",
      type: "select",
      options: CategoryOptions.map((role) => ({
        value: role.value,
        label: role.label,
      })),
      gridColumn: "span 2",
      required: true,
    },
  ];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { accountName, accountNumber, accountCategoryId, currency } =
        values;

      const mutationData = props.isEditing
        ? {
            id: props.data.Id,
            accountName,
            accountNumber,
            currency,
            accountSubcategoryId: accountCategoryId,
            identifierId: companyId,
            identifierType: 1,
          }
        : {
            accountName,
            accountNumber,
            currency,
            identifierId: companyId,
            accountSubcategoryId: accountCategoryId,
            identifierType: 1,
          };

      const response = await executeAnyMutation(
        props.isEditing ? "updateAccounts" : "createAccounts",
        mutationData,
        "accounts",
        false,
        base_url
      );

      if (response?.results) {
        props.onClose();
        props.onAction();

        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Account  ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={props.isEditing ? "Edit Account S" : "Create Account "}
      subtitle={
        props.isEditing ? "Edit an Existing Account " : "Create a New Account "
      }
    />
  );
};

export default AccountsForm;
